import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading5 extends ToolToggleBlock {
  static toolName = 'Heading 5';
  static iconClass = 'fa-regular fa-h5';
  static blockType = 'h5';
  static shortcut = 'Cmd+Option+5';
}

export default ToolToggleHeading5;
